import { MutationOptions, useMutation } from 'react-query';

import { deleteContacts } from '@app/store/transport-layer/document/address-book/bulk/contacts/delete';

export default function useDeleteContacts(options?: MutationOptions<unknown, Error, string[]>) {
  return useMutation<unknown, Error, string[]>(deleteContacts, options);
}
